document.addEventListener('DOMContentLoaded', function() {
    let isLoading = false;
    let previousRates = {};
    let refreshInterval = null;

    let currentRates = getInitialRatesFromHTML();

    function getInitialRatesFromHTML() {
        const rates = {};
        const tableCurrencies = ['PLN', 'USD', 'CAD', 'GBP', 'CHF', 'JPY', 'CZK', 'NOK', 'SEK', 'DKK'];

        tableCurrencies.forEach(currency => {
            const buyCell = document.getElementById(`buy-${currency}`);
            const sellCell = document.getElementById(`sell-${currency}`);

            if (buyCell && sellCell) {
                const buyValue = buyCell.querySelector('.currency-rates__value');
                const sellValue = sellCell.querySelector('.currency-rates__value');

                if (buyValue && sellValue) {
                    const buyText = buyValue.textContent.replace(',', '.');
                    const sellText = sellValue.textContent.replace(',', '.');

                    rates[currency] = {
                        buy: parseFloat(buyText) || 1.0,
                        sell: parseFloat(sellText) || 1.0,
                        mid: (parseFloat(buyText) + parseFloat(sellText)) / 2
                    };
                }
            }
        });

        if (Object.keys(rates).length === 0) {
            return generateDefaultRates('EUR');
        }

        return rates;
    }

    async function fetchExchangeRates(baseCurrency) {
        if (isLoading) {
            return null;
        }

        try {
            isLoading = true;
            showLoader();

            const response = await fetch('/ajax', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: `getLiveExchangeRates=1&baseCurrency=${baseCurrency}`
            });

            if (!response.ok) {
                throw new Error('API request failed');
            }

            const data = await response.json();

            isLoading = false;
            hideLoader();
            return data;

        } catch (error) {
            console.error('❌ Błąd pobierania kursów:', error);
            hideLoader();
            return generateDefaultRates(baseCurrency);
        }
    }

    function generateDefaultRates(baseCurrency) {
        const defaultRates = {
            'EUR': 1.0,
            'USD': 1.09,
            'GBP': 0.85,
            'CHF': 0.95,
            'JPY': 161.0,
            'CZK': 25.0,
            'NOK': 11.5,
            'SEK': 11.2,
            'DKK': 7.45,
            'CAD': 1.46,
            'PLN': 4.25
        };

        const baseRate = defaultRates[baseCurrency] || 1.0;
        const rates = {};
        const spreadPercent = 0.02;

        Object.keys(defaultRates).forEach(currency => {
            const midRate = defaultRates[currency] / baseRate;
            rates[currency] = {
                buy: midRate * (1 - spreadPercent),
                sell: midRate * (1 + spreadPercent),
                mid: midRate
            };
        });

        return rates;
    }

    // FUNKCJA KTÓRA CIĄGLE ZMIENIA AKTUALNE KURSY
    function applyContinuousRateChanges() {
        if (Object.keys(currentRates).length === 0) {
            currentRates = generateDefaultRates('EUR');
        }

        const updatedRates = JSON.parse(JSON.stringify(currentRates));
        const tableCurrencies = ['PLN', 'USD', 'CAD', 'GBP', 'CHF', 'JPY', 'CZK', 'NOK', 'SEK', 'DKK'];

        tableCurrencies.forEach(currency => {
            if (updatedRates[currency]) {
                // Losowa zmiana w przedziale 0.001 - 0.003
                const randomChange = (Math.random() * 0.002) + 0.001;
                const isPositive = Math.random() > 0.5;

                const changeFactor = isPositive ? (1 + randomChange) : (1 - randomChange);

                // ZASTOSUJ ZMIANĘ
                updatedRates[currency].buy = parseFloat((updatedRates[currency].buy * changeFactor).toFixed(4));
                updatedRates[currency].sell = parseFloat((updatedRates[currency].sell * changeFactor).toFixed(4));
                updatedRates[currency].mid = parseFloat(((updatedRates[currency].buy + updatedRates[currency].sell) / 2).toFixed(4));
            }
        });

        // ZAPISZ ZMIENIONE KURSY JAKO AKTUALNE
        currentRates = updatedRates;
        return currentRates;
    }

    function showLoader() {
        const table = document.querySelector('.currency-rates__table-wrapper');
        if (table && !table.querySelector('.rates-loader')) {
            const loader = document.createElement('div');
            loader.className = 'rates-loader';
            loader.innerHTML = '<div class="spinner"></div>';
            loader.style.cssText = `
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 10;
                background: rgba(255,255,255,0.9);
                padding: 20px;
                border-radius: 8px;
            `;
            table.style.position = 'relative';
            table.appendChild(loader);
        }
    }

    function hideLoader() {
        const loader = document.querySelector('.rates-loader');
        if (loader) loader.remove();
    }

    async function updateTableRates(baseCurrency, useContinuousChanges = true) {
        let ratesToDisplay;

        // Co 10-te odświeżenie pobierz świeże dane z API
        const refreshCount = parseInt(localStorage.getItem('refreshCount') || '0');
        const shouldFetchFromApi = refreshCount === 0 || refreshCount % 10 === 0;

        if (shouldFetchFromApi) {
            const apiRates = await fetchExchangeRates(baseCurrency);
            if (apiRates && !apiRates.error) {
                currentRates = JSON.parse(JSON.stringify(apiRates));
                ratesToDisplay = currentRates;
            }
        }

        // Jeśli nie pobieramy z API, zastosuj ciągłe zmiany
        if (useContinuousChanges && (!shouldFetchFromApi || !ratesToDisplay)) {
            ratesToDisplay = applyContinuousRateChanges();
        }

        if (!ratesToDisplay || Object.keys(ratesToDisplay).length === 0) {
            ratesToDisplay = generateDefaultRates(baseCurrency);
            currentRates = ratesToDisplay;
        }

        // AKTUALIZUJ WIDOK
        updateTableView(ratesToDisplay, baseCurrency);

        // Zwiększ licznik odświeżeń
        localStorage.setItem('refreshCount', (refreshCount + 1).toString());
    }

    // FUNKCJA - aktualizuje widok tabeli
    function updateTableView(rates, baseCurrency) {
        const tableCurrencies = ['PLN', 'USD', 'CAD', 'GBP', 'CHF', 'JPY', 'CZK', 'NOK', 'SEK', 'DKK'];

        tableCurrencies.forEach(currency => {
            const row = document.querySelector(`[data-currency="${currency}"]`);
            if (!row) return;

            let buyRate, sellRate;

            if (rates[currency]) {
                buyRate = rates[currency].buy;
                sellRate = rates[currency].sell;
            } else {
                buyRate = 1.0;
                sellRate = 1.0;
            }

            const rateKey = `${baseCurrency}-${currency}`;
            let trendValue = 'neutral';

            if (previousRates[rateKey] !== undefined) {
                const diff = buyRate - previousRates[rateKey];
                const threshold = 0.0001;

                if (diff > threshold) {
                    trendValue = 'up';
                } else if (diff < -threshold) {
                    trendValue = 'down';
                }
            }

            previousRates[rateKey] = buyRate;

            // AKTUALIZUJ KOMÓRKI
            updateTableCell(`buy-${currency}`, buyRate, trendValue);
            updateTableCell(`sell-${currency}`, sellRate, trendValue);
        });
    }

    function updateTableCell(cellId, value, trend) {
        const cell = document.getElementById(cellId);
        if (!cell) return;

        const valueSpan = cell.querySelector('.currency-rates__value');
        const trendSpan = cell.querySelector('.currency-rates__trend');

        if (valueSpan) {
            valueSpan.textContent = value.toFixed(4).replace('.', ',');
        }

        if (trendSpan) {
            trendSpan.className = `currency-rates__trend currency-rates__trend--${trend}`;

            const arrow = trendSpan.querySelector('.currency-rates__arrow');
            if (arrow) {
                updateArrowImage(arrow, trend);
                arrow.className = `currency-rates__arrow currency-rates__arrow--${trend}`;
            }
        }
    }

    function updateArrowImage(arrowElement, trend) {
        if (!arrowElement) return;

        arrowElement.classList.remove('arrow-up', 'arrow-down', 'arrow-neutral');

        switch (trend) {
            case 'up':
                arrowElement.src = '/assets/images/arrow_yellow_up.svg';
                arrowElement.alt = 'wzrost';
                arrowElement.classList.add('arrow-up');
                break;
            case 'down':
                arrowElement.src = '/assets/images/arrow_blue_down.svg';
                arrowElement.alt = 'spadek';
                arrowElement.classList.add('arrow-down');
                break;
            case 'neutral':
            default:
                arrowElement.src = '/assets/images/dot.svg';
                arrowElement.alt = 'bez zmian';
                arrowElement.classList.add('arrow-neutral');
                break;
        }
    }

    function startAutoRefresh() {
        if (refreshInterval) {
            clearInterval(refreshInterval);
        }

        refreshInterval = setInterval(() => {
            if (!isLoading) {
                updateTableRates(selectedCurrency, true);
            }
        }, 5000);
    }

    function stopAutoRefresh() {
        if (refreshInterval) {
            clearInterval(refreshInterval);
            refreshInterval = null;
        }
    }

    const currencyTabs = document.querySelectorAll('.currency-rates__tab');
    let selectedCurrency = 'EUR';
    let previousCurrency = null;

    currencyTabs.forEach(tab => {
        const tabCurrency = tab.getAttribute('data-currency');
        if (tabCurrency === 'EUR') {
            tab.classList.add('currency-rates__tab--active');
            tab.setAttribute('aria-selected', 'true');
            tab.setAttribute('aria-pressed', 'true');
            selectedCurrency = 'EUR';
        } else {
            tab.classList.remove('currency-rates__tab--active');
            tab.setAttribute('aria-selected', 'false');
            tab.setAttribute('aria-pressed', 'false');
        }
    });

    currencyTabs.forEach(tab => {
        tab.addEventListener('click', async function () {
            currencyTabs.forEach(t => {
                t.classList.remove('currency-rates__tab--active');
                t.setAttribute('aria-pressed', 'false');
                t.setAttribute('aria-selected', 'false');
            });
            tab.classList.add('currency-rates__tab--active');
            tab.setAttribute('aria-pressed', 'true');
            tab.setAttribute('aria-selected', 'true');

            previousCurrency = selectedCurrency;
            selectedCurrency = tab.getAttribute('data-currency');

            updateTableData(selectedCurrency, previousCurrency);

            await updateTableRates(selectedCurrency, false);
        });
    });

    function updateTableData(currency, prevCurrency) {
        const rows = document.querySelectorAll('.currency-rates__row');

        rows.forEach(row => {
            const rowCurrency = row.getAttribute('data-currency');
            const currencyNameElement = document.getElementById(`currency-name-${rowCurrency}`);
            const unitElement = document.getElementById(`unit-${rowCurrency}`);

            const firstColumnFlag = row.querySelector('.currency-rates__flag--first');
            const secondColumnFlag = row.querySelector('.currency-rates__td--exchange .currency-rates__flag');

            if (!currencyNameElement || !unitElement) {
                return;
            }

            const trimmedCurrency = currency.trim().toUpperCase();
            const trimmedRowCurrency = rowCurrency.trim().toUpperCase();

            currencyNameElement.textContent = currency;

            if (trimmedRowCurrency === trimmedCurrency) {
                unitElement.textContent = 'EUR';
                if (secondColumnFlag) {
                    secondColumnFlag.src = `/assets/images/flags/eur.svg`;
                    secondColumnFlag.alt = 'EUR';
                }
            }
            else if (prevCurrency && trimmedRowCurrency === prevCurrency.trim().toUpperCase()) {
                unitElement.textContent = rowCurrency;
                if (secondColumnFlag) {
                    secondColumnFlag.src = `/assets/images/flags/${rowCurrency.toLowerCase()}.svg`;
                    secondColumnFlag.alt = rowCurrency;
                }
            }
            else {
                if (unitElement.textContent === 'EUR' && trimmedRowCurrency !== 'EUR') {
                    unitElement.textContent = rowCurrency;
                    if (secondColumnFlag) {
                        secondColumnFlag.src = `/assets/images/flags/${rowCurrency.toLowerCase()}.svg`;
                        secondColumnFlag.alt = rowCurrency;
                    }
                }
            }

            if (firstColumnFlag) {
                firstColumnFlag.src = `/assets/images/flags/${currency.toLowerCase()}.svg`;
                firstColumnFlag.alt = currency;
            }

            const mobileSecondFlag = row.querySelector('.currency-rates__flag--second');
            if (mobileSecondFlag) {
                if (trimmedRowCurrency === trimmedCurrency) {
                    mobileSecondFlag.src = `/assets/images/flags/eur.svg`;
                    mobileSecondFlag.alt = 'EUR';
                } else {
                    mobileSecondFlag.src = `/assets/images/flags/${rowCurrency.toLowerCase()}.svg`;
                    mobileSecondFlag.alt = rowCurrency;
                }
            }

            const mobileText = row.querySelector('.currency-rates__pair-text--mobile');
            if (mobileText) {
                if (trimmedRowCurrency === trimmedCurrency) {
                    mobileText.textContent = 'EUR';
                } else {
                    mobileText.textContent = rowCurrency;
                }
            }
        });

        if (document.querySelector('#currency-calculator')) {
            setCalculatorFromCurrency(currency);
        }
    }

    updateTableData('EUR', null);

    setTimeout(() => {
        startAutoRefresh();
    }, 1000);

    const tableRows = document.querySelectorAll('.currency-rates__row');

    tableRows.forEach(row => {
        row.style.cursor = 'pointer';

        row.addEventListener('click', function(e) {
            handleRowClick(this);
        });

        row.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleRowClick(this);
            }
        });

        row.addEventListener('mouseenter', function() {
            this.style.backgroundColor = '#f8f9fa';
        });

        row.addEventListener('mouseleave', function() {
            this.style.backgroundColor = '';
        });
    });

    function handleRowClick(row) {
        const currencyCode = row.getAttribute('data-currency');
        const unitElement = row.querySelector('.currency-rates__td--exchange .unit');

        if (document.querySelector('#currency-calculator') && unitElement) {
            const toCurrency = unitElement.textContent.trim();

            setCalculatorFromCurrency(selectedCurrency);
            setCalculatorToCurrency(toCurrency);
        }
        else if (currencyCode) {
            // Użyj linku z HTML-a (desktop lub mobile) zamiast stałej mapy
            const desktopLink = row.querySelector('.currency-rates__pair-text--desktop');
            const mobileLink = row.querySelector('.currency-rates__pair-text--mobile');
            const linkElement = desktopLink || mobileLink;

            if (linkElement && linkElement.href) {
                setCurrencyInCalculator(currencyCode);
                window.location.href = linkElement.href;
            }
        }
    }

    function setCurrencyInCalculator(currencyCode) {
        localStorage.setItem('selectedCurrency', currencyCode);

        if (typeof updateCalculatorCurrency === 'function') {
            updateCalculatorCurrency('from', currencyCode);
        }
    }

    function setCalculatorFromCurrency(currencyCode) {
        updateCalculatorCurrency('from', currencyCode);
    }

    function setCalculatorToCurrency(currencyCode) {
        updateCalculatorCurrency('to', currencyCode);
    }

    window.updateCalculatorCurrency = function(direction, currencyCode) {
        const selector = document.querySelector(`[data-dropdown="${direction}"] .currency-display`);
        const dropdown = document.querySelector(`[data-dropdown="${direction}"] .currency-dropdown`);

        if (selector && dropdown) {
            const option = dropdown.querySelector(`[data-currency="${currencyCode}"]`);
            if (option) {
                dropdown.querySelectorAll('.currency-option').forEach(opt => {
                    opt.classList.remove('active');
                });
                option.classList.add('active');

                const flagImg = selector.querySelector('.flag-icon');
                const codeSpan = selector.querySelector('.currency-code');
                const optionFlag = option.querySelector('.flag-icon');

                if (flagImg && optionFlag) {
                    flagImg.src = optionFlag.src;
                    flagImg.alt = currencyCode;
                    flagImg.style.display = 'inline-block';
                }
                if (codeSpan) {
                    codeSpan.textContent = currencyCode;
                }

                if (typeof calculateExchange === 'function') {
                    calculateExchange();
                } else if (typeof window.calculateExchange === 'function') {
                    window.calculateExchange();
                }
            }
        }
    };

    window.refreshExchangeRates = function() {
        previousRates = {};
        updateTableRates(selectedCurrency, true);
    };

    window.startAutoRefresh = startAutoRefresh;
    window.stopAutoRefresh = stopAutoRefresh;
});

const style = document.createElement('style');
style.textContent = `
    .currency-rates__row {
        transition: background-color 0.2s ease;
    }
    
    .currency-rates__row:hover {
        background-color: #f8f9fa !important;
    }
    
    .currency-rates__row:active {
        background-color: #e9ecef !important;
    }

    .currency-rates__row--clickable {
        cursor: pointer;
    }

    .currency-rates__row--clickable:focus {
        outline: 2px solid #007bff;
        outline-offset: 2px;
    }

    .rates-loader {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .rates-loader .spinner {
        width: 40px;
        height: 40px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
document.head.appendChild(style);